// ============================================
// META PIXEL ID
// ============================================
const META_PIXEL_ID = '2288111705033398'

// Base Hotmart checkout URL
const HOTMART_BASE_URL = 'https://pay.hotmart.com/N104821626W'
const HOTMART_OFFER = 'diav4y78'

// Product info for events
const PRODUCT = {
  name: 'The Unstoppable Brain',
  value: 6.97,
  currency: 'USD',
  contentType: 'product',
  contentCategory: 'Ebook / Biohacking',
}

// ============================================
// COOKIE HELPERS
// ============================================
function getCookie(name: string): string | null {
  try {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null
    return null
  } catch {
    return null
  }
}

// ============================================
// UTM + ID CAPTURE WITH LOCALSTORAGE PERSISTENCE
// ============================================
const TRACKED_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'fbclid',
  'gclid',
]

function getParams(): Record<string, string> {
  try {
    const urlParams = new URLSearchParams(window.location.search)
    const params: Record<string, string> = {}

    TRACKED_KEYS.forEach((key) => {
      const value = urlParams.get(key)
      if (value) {
        params[key] = value
        localStorage.setItem('lp_' + key, value)
      } else {
        params[key] = localStorage.getItem('lp_' + key) || ''
      }
    })

    return params
  } catch {
    return {}
  }
}

// ============================================
// EXTERNAL ID FOR MATCH RATE
// ============================================
function getExternalId(): string {
  try {
    let externalId = localStorage.getItem('ext_id')
    if (!externalId) {
      externalId =
        'ext_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
      localStorage.setItem('ext_id', externalId)
    }
    return externalId
  } catch {
    return 'ext_' + Date.now()
  }
}

// ============================================
// CHECKOUT URL BUILDER
// ============================================
export function buildCheckoutURL(): string {
  try {
    const p = getParams()
    const fbp = getCookie('_fbp') || ''
    const fbc = getCookie('_fbc') || ''
    const externalId = getExternalId()

    // Build SCK/SRC attribution string
    const sckStr = `${p.utm_source || 'direct'}|${p.utm_medium || 'none'}|${p.utm_campaign || 'no_camp'}|${p.utm_content || 'no_cont'}`

    const url = new URL(HOTMART_BASE_URL)
    url.searchParams.set('off', HOTMART_OFFER)

    // Forward individual UTMs
    if (p.utm_source) url.searchParams.set('utm_source', p.utm_source)
    if (p.utm_medium) url.searchParams.set('utm_medium', p.utm_medium)
    if (p.utm_campaign) url.searchParams.set('utm_campaign', p.utm_campaign)
    if (p.utm_content) url.searchParams.set('utm_content', p.utm_content)
    if (p.utm_term) url.searchParams.set('utm_term', p.utm_term)

    // SCK/SRC for Hotmart attribution
    url.searchParams.set('sck', sckStr)
    url.searchParams.set('src', sckStr)

    // CAPI support — _fbp, _fbc, and external_id
    if (fbp) url.searchParams.set('fbp', fbp)
    if (fbc) url.searchParams.set('fbc', fbc)
    if (externalId) url.searchParams.set('external_id', externalId)

    return url.toString()
  } catch {
    return `${HOTMART_BASE_URL}?off=${HOTMART_OFFER}`
  }
}

// ============================================
// NOTE: Meta Pixel base code is installed in index.tsx
// It fires 'PageView' on load automatically.
// ============================================

// ============================================
// META PIXEL EVENTS
// ============================================
export function trackViewContent(): void {
  try {
    if (!(window as any).fbq) return
    const externalId = getExternalId()
    ;(window as any).fbq('track', 'ViewContent', {
      content_name: PRODUCT.name,
      content_category: PRODUCT.contentCategory,
      content_type: PRODUCT.contentType,
      value: PRODUCT.value,
      currency: PRODUCT.currency,
      external_id: externalId,
    })
  } catch (err) {
    console.warn('[Tracking] ViewContent event failed:', err)
  }
}

export function trackInitiateCheckout(): void {
  try {
    if (!(window as any).fbq) return
    const externalId = getExternalId()
    ;(window as any).fbq('track', 'InitiateCheckout', {
      content_name: PRODUCT.name,
      value: PRODUCT.value,
      currency: PRODUCT.currency,
      external_id: externalId,
    })
  } catch (err) {
    console.warn('[Tracking] InitiateCheckout event failed:', err)
  }
}

// ============================================
// CHECKOUT REDIRECT (with tracking)
// ============================================
export function goToCheckout(): void {
  try {
    trackInitiateCheckout()
  } catch {
    // Tracking failure should never block checkout
  }

  // Small delay to allow pixel event to fire, then redirect
  const url = buildCheckoutURL()
  setTimeout(() => {
    window.location.href = url
  }, 300)
}
